import { DropdownItem, DropdownList, MultiSelectItem, Platba, WorkersWithCostCenter } from '@/main/store/@types/dropdown.d';
import { Table, Row } from '@/main/utils/table';
import { EditStore, DepTables, EditStoreProps } from '@/main/store/@types/edit.d';
import { DependetTableSetting } from '@/main/store/@types/store.d';

import { ElsaRExternalUrls } from '../types';
import {
	SAGA_2_HLAV,
	SAGA_2_KOM,
	SAGA_2_POL,
	VYDEJKAND,
	ZAKAZKA_DRUH,
	ZAKAZKA_PLAN_SKUT,
	PNEU,
	ZAKAZKA_ZAPUJCKA,
	ZAKAZKA_CONTROL,
	GDPR,
	PENDING_JOB_LIST,
	KOREKCE,
	CIZI_VYKONY,
	VYDEJKA,
	PRACOVNI_POZICE,
	REF_TABLE,
	RESERVE_PARTS,
	ZAKAZKA_ND,
	DEPENDENT_TABLES,
	DOKLAD_OSTATNI,
	ADVANCEPAY,
	ZAK_ZALOHA,
	ODLOZENE_SERVISNI_CINNOSTI,
	OZAKAZKA_ON_VOZIDLO, OTEVRENE_ZAKAZKY, ATTACHMENT_FILES, PlatbaTyp,
	POLOZKY,
	ZAKAZKA_ND_PENDING,
	ZAKAZKA_PP_PENDING,
	SERVICE_PKG_PARTS,
	SERVICE_PKG_LABOR,
	NONGENUINE_ATTACHMENT_FILES,
	CAMPAIGN_DETAILS,
	SERVICE_JOB_DETAILS,
} from '../../constants';
import { CUSTOMER_FEEDBACK } from '../../components/customerFeedback/constants';

export class ZakazkaDropdownList implements DropdownList {
	ZakazkaDruh = [];
	VyrobekvozOzn = [];
	PlatbaPzn = [] as Platba[];
	MenaId2 = [];
	IntrDruhOzn = [];
	NoraPzn = [];
	ProvozovnaId = [];
	SkladOzn = [];
	SmluvpartnerPzn = [];
	ZakaznikSk = [];
	FakturacniProfil = [];
	ZakaznikSkInterni = [];
	FakturacniProfilInterni = [];
	SmVariaList = [];
	KalkulacePzn = [];
	RrStatus = [];
	SafetyRemarks = [];
	OrderSubType = [] as DropdownItem[];
	[key: string]: DropdownItem[];
	COMMUNICATION_MODE_ID = [];
	CancellationReason = [];
	Reports = [] as DropdownItem[];
	WarrantyKeyCodes = [];
	OrderReportTypes = [];
	ServiceJobs = [] as any[];
	LaborCodes = [] as DropdownItem[];
	DefaultLaborList = [] as DropdownItem[];
	ServiceJobForItems = [] as DropdownItem[];
	CostCenter = [] as DropdownItem[];
	Workers = [] as WorkersWithCostCenter[];
	EGUISelectedPaymentMethod = [] as Platba[];
	DefaultPartsList = [] as DropdownItem[];
	
	//External LO
	ExtLoCodes=[] as DropdownItem[];
	ExternalOperationType=[] as DropdownItem[];
	LocalSuppliers = [] as DropdownItem[];
	UnitOfMeasurements= [] as DropdownItem[];
	EguiTypes = [];
	EguiTransDisplayOptions = [];
	EguiMultiSelectTypes = [];

}

type calcButtonsDisabled = {
	Odeslat: boolean,
	Najit: boolean,
	Otevrit: boolean,
	Prevzit: boolean,
	Vymaz: boolean,
	OdpisPp: boolean,
	OdpisJfnd: boolean,
};

export class LocalState {
	multipleSelection: Row[] = [];
	frontaNDCount: number = 0;
	paketyCount: number = 0;
	showIntCard: boolean = false;
	prevRouteName: string | null = null;
	PnvNr: number | null = null;
	NvskladIdText: string | null = null;
	NvozidloVin: string | null = null;
	PnvKomiseNr: string | null = null;
	selectedTab: string | null = null;
	mioZakazkaIdNr: number | null = null;
	mioZakazkaIdText: string | null = null;
	mioZakazkaId: number | null = null;
	isKalkulaceSentToRemote: boolean | null = null;
	displayCalcButtons: boolean | null = null;
	calcButtonsDisabled: calcButtonsDisabled | null = null;
	isZpracuj: boolean = false;
	kalkulaceTable: Table | null = null;
	elsaRExternalUrls: ElsaRExternalUrls[] = [];
	isReleasedOrder: boolean | null = null;
	IsGatePassAvailable: boolean = false;
	optinalCampaignCount: number | null = 0;
	mandatoryCampaignCount: number = 0;
	viewDialogCampaign: boolean = false;
	isViewCampaignBtnClicked: boolean = false;
	CampaignTable: any[] = [];
	CampaignData: any[] = [];
	SelectedCampaign: number | null = null;
	CampaignCount: number | null = 0;
	SplitOrderValidationPopup: boolean | null = false;
	ShowDialogPendingJoblist: boolean | null = false;
	notificationDialogforWatchlisted: boolean | null = null;
	notificationDialogforWatchlistedMsg: string | null = null;
	carDescription = {
		loadingCount: 0,
		enabled: false,
		entryData: new Table(),
		equipmentData: new Table(),
		visible: false,
	};


	tiskDialog = {
		visible: false as boolean | null,
		url: null as string | null,
		filter: null as Record<string, any> | null,
		fetchPdfProvider: null as ((filter: {}) => Promise<any>) | null,
		dialogClosed: () => { },
	};

	showInfoSideBar = true;
}

export class Edit {
	ServicePackageTxt: string | null = null;
	CategoryName: string | null = null;
	ServiceOrderType: string | null = null;
	PackageType: string | null = null;
	ServicePackageId: number | null = null; // TODO: check
	ZakazkaIdRefText: string | null = null; // TODO: check
	ZakaznikCDB: number | null = null; // TODO: check
	VyrobekvozOzn: string | null = null; // TODO: check
	DobropDokNr: number | null = null;
	DobropDokPfx: string | null = null;
	DrMatPc: number | null = null;
	DrMatSzb: number | null = null;
	DzmDuvod: string | null = null;
	DzmKmLimit: number | null = null;
	DzmPlatnostDat: string | null = null;
	DzmStatus: number | null = null;
	EditDat: string | null = null;
	EditPracId: number | null = null;
	EditPracIdText: string | null = null;
	FakturaceprofilId: number | null = null;
	GarNdRez: boolean | null = null;
	CheckinId: number | null = null;
	InclusivPrp: boolean | null = null;
	IntDruhDuvod: string | null = null;
	CustDocReminder: boolean | null = null;
	IsCustRevisit: boolean | null = null;
	IntFakturaceprofilId: number | null = null;
	IntrDruhOzn: number | null = null;
	IntSlevaCv: number | null = null;
	IntSlevaEmise: number | null = null;
	IntSlevaLak: number | null = null;
	IntSlevaMat: number | null = null;
	IntSlevaPujcpa: number | null = null;
	IntSlevaSlz: number | null = null;
	JinyprijemceId: number | null = null;
	JinyprijemceIdText: string | null = null;
	KzakazkaId: number | null = null;
	LakdruhId: number | null = null;
	LakdruhOzn: string | null = null;
	LakdruhOznText: string | null = null;
	LeasCisSchval: string | null = null;
	LeaszakaznikId: number | null = null;
	LeaszakaznikIdText: string | null = null;
	Memo: string | null = null;
	MimoKusPrp: boolean | null = null;
	NabidkaPrp: boolean | null = null;
	NoraPzn: number | null = null;
	OrderSubtypeId: number | null = null;
	NvozidloId: number | null = null;
	NvskladId: number | null = null;
	ObchPripadId: number | null = null;
	OprPoNehodePrp: boolean | null = null;
	OtevreniDat: string | null = null;
	OtevreniPracId: number | null = null;
	OtevreniPracIdText: string | null = null;
	OvozidloId: number | null = null;
	OvozidloIdText: string | null = null;
	Oznam: string | null = null;
	PmPracId: number | null = null;
	PmPracIdText: string | null = null;
	PmVstupDat: string | null = null;
	PnvId: number | null = null;
	PodilMatGd: number = 0;
	PodilMatInt: number = 0;
	PodilMatZak: number = 0;
	PodilSlzGd: number = 0;
	PodilSlzInt: number = 0;
	PodilSlzZak: number = 0;
	PojistCisExtzaklikv: string | null = null;
	PojistCisPu: string | null = null;
	PojistovnaId: number | null = null;
	PojistovnaIdText: string | null = null;
	PojistDpuDat: string | null = null;
	PovId: number | null = null;
	PovNr: string | null = null;
	PracovnikId: number | null = null;
	PracovnikIdText: string | null = null;
	PracovnikOsobniCis: string | null = null;
	PrevodMax: number | null = null;
	ProvozovnaId: number | null = null;
	Saga2Prp: boolean | null = null;
	IsOrderSentToSaga: boolean | null = null;
	SdaMancheckPracId: number | null = null;
	SdaMancheckState: boolean | null = null;
	SkladOzn: number | null = null;
	WarehouseId:number | null = null;
	SlevaCv: number | null = null;
	SlevaEmise: number | null = null;
	SlevaLak: number | null = null;
	SlevaMat: number | null = null;
	SlevaMatOnd: number | null = null;
	SlevaMatOpr: number | null = null;
	SlevaPujcpa: number | null = null;
	SlevaSlz: number | null = null;
	SmluvpartnerId: number | null = null;
	SmluvpartnerIdText: string | null = null;
	SmluvpartnerPzn: number | null = null;
	SmVariaList: MultiSelectItem[] | null = [];
	Terminal: string | null = null;
	TextRtf: string | null = null;
	UvolneniDat: string | null = null;
	UvolneniPracId: number | null = null;
	UvolneniPracIdText: string | null = null;
	UzavreniDat: string | null = null;
	VozidloId: number | null = null;
	VozidloRzv: string | null = null;
	VozidloVin: string | null = null;
	VozidloText: string | null = null;
	VstupDat: string | null = null;
	VstupPracId: number | null = null;
	VstupPracIdText: string | null = null;
	VstupProvId: number | null = null;
	VydejkandTxt: string | null = null;
	VyrazenPrp: boolean | null = null;
	ZakazkaBcode: string | null = null;
	ZakazkaDruh: ZAKAZKA_DRUH | null = null;
	ZakazkaId: number = 0;
	IsElsaProAutosync: boolean | null = false;
	ZakazkaIdRef: number | null = null;
	ZakazkaNr: number | null = null;
	ZakaznikId: number | null = null;
	ZakaznikIdText: string | null = null;
	ZakazsplitPrp: boolean | null = null;
	ZakRefBlokPrp: boolean | null = null;
	CenaCelkem: number | null = null;
	OldTotalPrice:number | null = null;
	IsAdditionalAmountDisabled: boolean | null = false;
	ZakaznikSk: number | null = null;
	ShowGatepassButton: boolean | null = null;
	IsBezMarze: boolean | null = null;
	PrevodMaxLimit: number | null = null;
	IntZakaznikSk: number | null = null;
	Stav: number | null = null;
	IntrDruhOznLabel: string | null = null;
	IsInterni: boolean | null = null;
	IsInterniNS: boolean | null = null;
	VozidloIsSet: boolean | null = null;
	CanChangePojistCis: boolean | null = null;
	CanChangeLeasCis: boolean | null = null;
	IntrDruhOznText: string | null = null;
	InterDruhNs: number | null = null;
	IntrDruhPrp: boolean | null = null;
	InterDruhDuvodPrp: boolean | null = null;
	SdaCheckPzn: number | null = null;
	NoticeList: any[] | null = null;
	SdaOnlineCheck: string | null = null;
	ZakazkaListId: number | null = null;
	PocetOtevrenychZakazek: number | null = null;
	PocetZavad: number | null = null;
	PocetObjednavek: number | null = null;
	CdbStatusZakaznika: string | null = null;
	CdbIkonky: number | null = null;
	Dzm: boolean | null = null;
	DzmExtEnum: number | null = null;
	VozForSaga2: boolean | null = null;
	PodilGd: boolean | null = null;
	PodilInt: boolean | null = null;
	PodilZak: boolean | null = null;
	KalkulacePzn: number | null = null;
	KalkPracovnikId: number | null = null;
	KalkPracovnikIdText: string | null = null;
	KalkPracovnikOsobniCislo: string | null = null;
	KalkProvozovnaId: number | null = null;
	KalkStredNaklOzn: number | null = null;
	KalkStredNaklOznText: string | null = null;
	KalkPreviewRtf: string | null = null;
	CanChangeUvolneniKulGar: boolean | null = null;
	CanChangeCheckIn: boolean | null = null;
	CanEditVozidlo: boolean | null = null;
	CanEditZakaznik: boolean | null = null;
	CanChangePrevodMax: boolean | null = null;
	CanChangeNoraPzn: boolean | null = null;
	UrovenPole: number | null = null;
	Saga2Pocet: number | null = null;
	Saga2Status: string | null = null;
	CanFakturace: boolean | null = null;
	CheckinVstupDat: null | string = null;
	CheckinNr: number | null = null;
	VydejkaPrpt: boolean | null = null;
	PlatbaPzn: PlatbaTyp | null = null;
	AdvancePayment: number | null = null;
	MenaId2: number | null = null;
	AdvancePaymentPrp: boolean | null = null;
	PaymentReferenceNumber: string | null = null;
	RrStatusCode: string | null = null;
	RrDescription: string | null = null;
	CancellationReason: string | null = null;
	CancellationReasonType: number | null = null;
	IsCancellationReason: boolean | false = false;
	IsCancellationRemarks: boolean | false = false;
	IsCancellationButton: boolean | false = false;
	ZaznamId: number | null = null;
	DiscountVal: number | null = null;
	Sleva: number | null = null;
	Remarks: string | null = null;
	IsCustomerFirstVisit: boolean | null = null;
	FirstVisitVisible: boolean | null = false;
	EnableRegionFlag: boolean | null = null;
	IsJoblistApproved: number | null = null;
	DisabledFeedback: boolean | true = true;
	CustomerFeedbackRating: number | null = null;
	IsSafetyRemarks: boolean | false = false;
	IsAllItemLevelStatusEntered: boolean | null = null;
	CustomerRemarks:string | null = null;
	VehicleRemarks:string | null = null;
	SafetyRemarks:string | null = null;
	IsPotentialLead: boolean | false = false;
	IsNonGenuine: boolean | null = false;
	LeadRemarks:string | null = null;
	LeadType:string | null = null;
	NonGenuineRemark: string | null = null;
	WatchlistFlag: boolean | null = null;
	NotificationMsg: string | null = null;
	CatName: string | null = null;
	EnableJoblist: boolean = false;
	IsWatchlisted: boolean = false;
	CompareWatchlist: boolean = false;
	IsWatchlistedVehicle: boolean | null = null;
	Notificationmessage: string | null = null;

	TotalCostLimit: number | null = null;
	TotalLimitRemark: string | null = null;
	CommunicationModeId: number | null = null;
	AdditionalJobStatus: number | null = null;
	AdditionalPartStatus: number | null = null;
	IsApprovalDropDownVisible: boolean = true;
	QuoteExpiryDate: Date | null = null;
	IsWatchlistedRejected: boolean = false;
	StatusResult: boolean = false;
	HealthCardCheckList: CheckboxItem[] = [];
	ReportID: string | null = null;
	IsImportantCustomer : boolean | null = null;
	IsSplittedOrder: boolean | null = null;
	IsMandatoryCampaign: boolean | null = null;
	IsOptionalCampaign: boolean | null = null;
	GenerateWarrantyKey: boolean | null = null;
	WarrantyKeyCode: string | null = null;
	IsTotalLoss: boolean | null = false;
	TotalLossRemark: string | null = null;
	TotDiscPercentLabor: number | null = null;
	TotDiscValLabor: number | null = null;
	TotDiscPercentParts: number | null = null;
	TotDiscValParts: number | null = null;
	TotDiscPercent: number | null = null;
	TotDiscVal: number | null = null;
	CancellationRemarks: string | null = null;
	OthersType: number | null = null;
	ServiceJobs: any[] | null = null;
	SelectedCampaignId: number | null = null;
	IsPartialInvoiced: boolean | null = false;
	IsOEMPartyBilled: boolean | null = false;
	LaborOperations: any[] | null = [];
	PartsOperations: any[] | null = null;
	EGUIInvoiceNumber: string | null = null;
	IsPartialCreditNoteGenerated: boolean | null = false;
	ServiceJobDetails: any[] | null = [];
	IsGUIEnabled: boolean | null = false;
	IsReopenOrder: boolean | null = false;
	EGUISelectedPaymentMethod: MultiSelectItem[] = [];
	DefaultWarehouseId: number | null = null;
	ExtLaborOperations: any[] | null = [];
	IsDNPVisible: boolean | null = false;

	EguiTypes: number | null = null;
	EguiTransDisplayOptions: number | null = null;
	EguiMultiSelectTypes: MultiSelectItem[] = [];
	CashAmount: number = 0;
	CreditAmount: number = 0;
	DebitAmount: number = 0;
	OnlineAmount: number = 0;
	EguiTypesSecond: number | null = null;
	IsOrderCancelInSaga: boolean | null = null;
	IsElsaREnabled: boolean | null = false;
	IsOpenOrder: boolean | null = false;
	IsCreditNoteProcessed: boolean | null = false;
	IsPartialInvoice: boolean | null = false;

	//Entity Counts 
	AdvancePaymentCount: number = 0;
	PartsCount: number = 0;
	LaborsCount: number = 0
	ExtLaborCount: number = 0;
	DiscountCount: number = 0
	HistoryCount: number = 0;
	ReserveFormCount: number = 0;
	NonGenuineAttachementFilesCount: number = 0;
	InvoicesCount: number = 0;
	AttachmentFilesCount: number = 0
	Saga2Count: number = 0;
	Saga2CommunicationsCount: number = 0
	Saga2PolCount: number = 0; 
	ZakazkaZapujckaCount: number = 0;
	ZakazkaPneuCount: number = 0;
	ContactTypeId: number | null = null;
	UpdatedServiceJobIds: number[] = [];
    CustomerContactDetails: CustomerContactDto[] | null = [];
	SelectedCustomerContactDetail: CustomerContactDto | null = {
		Id: 0,
		SfContactId: null,
		Name: null,
		Email: null,
		Phone: null,
		Mobile: null,
		Zip: null,
		City: null,
		Address: null,
		Relationship: null,
		ContactTypeId: 0,
		ContactTypeText: null,
		CustomerId: 0,
		LastModifiedTimeAtSF: '',
		CreatedAt: '',
		UpdatedAt: ''
	};

	CanAddPartOrLabour: boolean = false;
	CanAddExtLabour: boolean = false;
}

export interface CustomerContactDto {
	Id: number;
	SfContactId: number | null;
	Name: string | null;
	Email: string | null;
	Phone: string | null;
	Mobile: string | null;
	Zip: string | null;
	City: string | null;
	Address: string | null;
	Relationship: string | null;
	ContactTypeId: number;
	ContactTypeText: string | null;
	CustomerId: number;
	LastModifiedTimeAtSF: Date | string;
	CreatedAt: Date | string;
	UpdatedAt: Date | string;
}
export interface CheckboxItem {
	ItemDesc: string,
	ItemId: boolean,
}
interface ZakazkaProps extends EditStoreProps {
	filter?: object
	id?: number;
	zakazkaDruh?: string,
}
export const props = {
	mode: null,
} as ZakazkaProps;

export type State = EditStore<Edit, ZakazkaDropdownList, LocalState, DepTables<typeof DEPENDENT_TABLES>, typeof props>;

export const depTableSettings: Record<string, DependetTableSetting<State>> = {
	[POLOZKY]: {
		filter(state) {
			return {
				VozidloId: state.edit.VozidloId,
				ZakazkaID: state.edit.ZakazkaId,
			};
		},
	},
	[ZAKAZKA_ND]: {
		isEditable: true,
		loadByEntityId: true,
		columns: {
			BILL_TO: { isEditable: false, required: false, type: 'text', minWidth: '100px' },
			NOTE: { isEditable: true, required: false, type: 'text', minWidth: '100px' },
			PC_JDN_ZKR: { isEditable: false, required: false, type: 'text', minWidth: '100px' },
			SERVICE_JOB_ID: { isEditable: true, required: false, type: 'dropdown', minWidth: '200px' },
			DISCOUNT_PERCENT: { isEditable: true, required: false, type: 'decimal', minWidth: '150px' },
			DISCOUNT_VAL: { isEditable: true, required: false, type: 'decimal', minWidth: '150px' },
			TEXT: { isEditable: true, required: true, type: 'text', minWidth: '150px' },
			IS_ADDITIONAL: { isEditable: false, required: false, type: 'checkbox', minWidth: '150px' },
			LINE_ITEM_STATUS_ID: { isEditable: true, required: false, type: 'dropdown', minWidth: '150px' },
			PENDING_REASON_ID: { isEditable: true, required: false, type: 'dropdown', minWidth: '150px' },
			PENDING_REMARKS_OTHERS: { isEditable: true, required: false, type: 'text', minWidth: '150px' },
			RRP_UNIT_PRICE: { isEditable: true, required: false, type: 'decimal', minWidth: '150px' },
			TECHNICIAN: { isEditable: true, required: false, type: 'dropdown', minWidth: '200px' },
			WARRANTY_PRICE: { isEditable: true, required: false, type: 'decimal', minWidth: '150px' },
		},
		filter(state) { return { ZakazkaId: state.props.id }; },
	},
	[ZAKAZKA_ND_PENDING]: {
		loadByEntityId: true,
		filter(state) {
			return { ZakazkaId: state.props.id, PendingItem: 2 };
		},
	},
	[SERVICE_PKG_PARTS]: {
		loadByEntityId: true,
		filter(state) {
			return { ServicePackageId: state.edit.ServicePackageId ? state.edit.ServicePackageId : 0 };
		},
	},
	[SERVICE_PKG_LABOR]: {
		loadByEntityId: true,
		filter(state) {
			return { ServicePackageId: state.edit.ServicePackageId ? state.edit.ServicePackageId : 0 };
		},
	},
	[RESERVE_PARTS]: {
		loadByEntityId: false,
		filter(state) {
			return { ZakazkaId: state.props.id ? state.props.id : 0 };
		},
	},
	[REF_TABLE]: {
		loadByEntityId: false,
		filter(state) {
			return { ZakazkaId: state.props.id ? state.props.id : 0 };
		},
	},
	[PRACOVNI_POZICE]: {
		loadByEntityId: true,
		isEditable: true,
		columns: {
			PP_NR: { isEditable: true, required: true, type: 'text', minWidth: '250px' },
			TEXT: { isEditable: true, required: true, type: 'text', minWidth: '250px' },
			NOTE: { isEditable: true, required: false, type: 'text', minWidth: '250px' },
			BILL_TO: { isEditable: false, required: false, type: 'text', minWidth: '250px' },
			PC_PP_SL_PO: { isEditable: false, required: false, type: 'text', minWidth: '250px' },
			IS_ADDITIONAL: { isEditable: true, required: false, type: 'checkbox', minWidth: '250px' },
			DISCOUNT_PERCENT: { isEditable: true, required: false, type: 'number', minWidth: '250px' },
			DISCOUNT_VAL: { isEditable: true, required: false, type: 'decimal', minWidth: '150px' },
			SERVICE_JOB_NAME: { isEditable: true, required: false, type: 'dropdown', minWidth: '250px' },
			COST_CENTER: { isEditable: true, required: true, type: 'dropdown', minWidth: '250px' },
			LABOR_WARRANTY_PRICE: { isEditable: true, required: false, type: 'decimal', minWidth: '150px' },
		},
		filter(state) {
			return { ZakazkaId: state.props.id ? state.props.id : 0 };
		},
	},
	[SERVICE_JOB_DETAILS]: {
		isEditable: true,
		columns: {
			SERVICE_JOB_ID: { isEditable: true, required: true, type: 'text', minWidth: '250px' },
			SERVICE_JOB_DESCRIPTION: { isEditable: false, required: false, type: 'text', minWidth: '250px' },
			SERVICE_JOB_COMMENTS: { isEditable: true, required: false, type: 'text', minWidth: '250px' },
			BILL_TO: { isEditable: false, required: false, type: 'text', minWidth: '250px' },
		},
		filter(state) {
			return { serviceOrderId: state.props.id ? state.props.id : 0 };
		},
	},
	[ZAKAZKA_PP_PENDING]: {
		loadByEntityId: true,
		filter(state) {
			return { ZakazkaId: state.props.id ? state.props.id : 0, IsPendingItem: 2 };
		},
	},
	[VYDEJKA]: {
		loadByEntityId: false,
		filter(state) {
			return { ZakazkaId: state.props.id ? state.props.id : 0 };
		},
	},
	[CIZI_VYKONY]: {
		loadByEntityId: true,
		isEditable: true,
		columns: {
			CV_NR: { isEditable: true, required: true, type: 'dropdown', minWidth: '250px' },
			EXTERNAL_OPERATION_TYPE_ID: { isEditable: true, required: true, type: 'dropdown', minWidth: '250px' },
			TEXT: { isEditable: true, required: true, type: 'text', minWidth: '250px' },
			EXT_LO_UNIT_PRICE: { isEditable: true, required: true, type: 'number', minWidth: '250px' },
			COST: { isEditable: false, required: true, type: 'number', minWidth: '250px' },
			DISCOUNT_PERCENT: { isEditable: true, required: false, type: 'number', minWidth: '250px' },
			DISCOUNT_VAL: { isEditable: true, required: false, type: 'decimal', minWidth: '150px' },
			EXT_LO_QUANTITY: { isEditable: true, required: true, type: 'number', minWidth: '250px' },
			SERVICE_JOB_NAME: { isEditable: true, required: false, type: 'dropdown', minWidth: '250px' },
			UNIT_OF_MEASUREMENT: { isEditable: true, required: true, type: 'dropdown', minWidth: '250px' },
			BILL_TO: { isEditable: false, required: false, type: 'text', minWidth: '250px' },	
			SUPPLIER_NAME: { isEditable: true, required: true, type: 'dropdown', minWidth: '250px' },
			PC_PP_SL_PO: { isEditable: false, required: false, type: 'text', minWidth: '250px' },

		},
		filter(state) {
			return { ZakazkaId: state.props.id ? state.props.id : 0 };
		},
	},
	[KOREKCE]: {
		loadByEntityId: false,
		filter(state) {
			return { ZakazkaId: state.props.id ? state.props.id : 0 };
		},
	},
	[GDPR]: {
		loadByEntityId: false,
		filter(state) {
			if (state.edit.ZakaznikId) {
				return {
					ZakaznikId: state.edit.ZakaznikId,
					VyrobekvozOzn: state.edit.VyrobekvozOzn,
				};
			}
			return {};
		},
	},
	[PENDING_JOB_LIST]: {
		filter(state) {
			if (state.edit.VozidloId) {
				return {
					VozidloId: state.edit.VozidloId,
				};
			}
			return {};
		},
	},
	[CUSTOMER_FEEDBACK]: {
		loadByEntityId: false,
		filter(state) {
			if (state.edit.ZakazkaId) {
				return {
					ZakazkaId: state.props.id ? state.props.id : 0,
				};
			}
			return {};
		},
	},
	[VYDEJKAND]: {
		loadByEntityId: true,
		filter(state) {
			return { ZakazkaId: state.props.id ? state.props.id : 0 };
		},
	},
	[ZAKAZKA_CONTROL]: {
		loadByEntityId: true,
		filter(state) {
			return { ZakazkaId: state.props.id ? state.props.id : 0 };
		},
	},
	[DOKLAD_OSTATNI]: {
		loadByEntityId: true,
		filter(state) {
			return { ZakazkaId: state.props.id ? state.props.id : 0 };
		},
	},
	[ATTACHMENT_FILES]: {
		loadByEntityId: true,
		filter(state) {
			return { ZakazkaId: state.props.id ? state.props.id : 0 };
		},
	},
	[NONGENUINE_ATTACHMENT_FILES]: {
		loadByEntityId: false,
		filter(state) {
			return { VozidloId: state.edit.VozidloId };
		},
	},
	[CAMPAIGN_DETAILS]: {
		loadByEntityId: true,
		filter(state) {
			return { VozidloVin: state.edit.VozidloVin, ZakazkaId: state.edit.ZakazkaId };
		},
	},
	[ADVANCEPAY]: {
		loadByEntityId: true,
		filter(state) {
			return { ZakazkaId: state.props.id ? state.props.id : 0 };
		},
	},
	[ZAKAZKA_ZAPUJCKA]: {
		loadByEntityId: false,
		filter(state) {
			return { ZakazkaId: state.props.id ? state.props.id : 0 };
		},
	},
	[PNEU]: {
		loadByEntityId: false,
		filter(state) {
			return { ZakazkaId: state.props.id ? state.props.id : 0 };
		},
	},
	[SAGA_2_HLAV]: {
		loadByEntityId: true,
		filter(state) {
			return { ZakazkaId: state.props.id ? state.props.id : 0 };
		},
	},
	[SAGA_2_POL]: {
		loadByEntityId: true,
		filter(state) {
			return { ZakazkaId: state.props.id ? state.props.id : 0 };
		},
	},
	[SAGA_2_KOM]: {
		loadByEntityId: true,
		filter(state) {
			return { ZakazkaId: state.props.id ? state.props.id : 0 };
		},
	},
	[ZAKAZKA_PLAN_SKUT]: {
		loadByEntityId: false,
		filter(state) {
			return { ZakazkaId: state.props.id ? state.props.id : 0 };
		},
	},
	[ZAK_ZALOHA]: {
		loadByEntityId: false,
		filter(state) {
			return { ZakazkaId: state.props.id ? state.props.id : 0 };
		},
	},
	[ODLOZENE_SERVISNI_CINNOSTI]: {
		loadByEntityId: false,
		filter(state) {
			return { VozidloId: state.edit.VozidloId };
		},
	},
	[OZAKAZKA_ON_VOZIDLO]: {
		loadByEntityId: false,
		filter(state) {
			return { Spz: state.edit.VozidloRzv, ZakaznikId: state.edit.ZakaznikId };
		},
	},
	[OTEVRENE_ZAKAZKY]: {
		loadByEntityId: false,
		filter(state) {
			return {
				OtevrenePrp: true,
				PripravaPrp: true,
				UzavrenePrp: false,
				Spz: state.edit.VozidloRzv,
				KaroserieNr: state.edit.VozidloVin,
			};
		},
	},

};
